<template>
<div>
  <h2 class="text-[13px] font-semibold text-[#23569F] uppercase leading-[1.5]">{{ $t('label.serialNumber') }}</h2>
  <el-row>
    <el-col :span="10" :offset="8">
      <div class="grid-content">
        <player-setup-form-error :message="formError" :display="formError != ''" height="medium" />
        <el-form
            @submit.prevent="triggerFormSubmit"
            ref="refFormSerial"
            :rules="modelRules"
            :model="model"
            class="common-form">
          <el-form-item :label="$t('label.serialNumber')" prop="serial">
            <el-input
              ref="serialInput"
              :autofocus="true"
              :disabled="isFormDisabled"
              v-model="model.serial"
              :placeholder="$t('label.serialNumber')">
              <template #suffix>
                <span v-if="model.serial" class="flex cursor-pointer" @click="() => $refs.serialInput.clear()">
                  <el-icon class="text-[#c0c4cc] hover:text-[#909399]"><CircleClose /></el-icon>
                </span>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script src="./player-setup-serial.js"></script>
